const Customer = {
  init(target) {
    const customerBtn = target.querySelector('.customer__dropdown-button')
    const customerDropdown = target.querySelector('.customer__dropdown')

    if (customerBtn && customerDropdown) {
      customerBtn.addEventListener('click', (e) => this.onClick(e, customerDropdown))
      document.addEventListener('click', (e) => this.isClickInside(e, customerDropdown))
    }
  },
  onClick(e, customerDropdown) {
    e.preventDefault()
    e.stopPropagation()

    if (this.isOpen(customerDropdown)) {
      this.doClose(customerDropdown)
    } else {
      this.doOpen(customerDropdown)
    }
  },
  isOpen(customerDropdown) {
    return customerDropdown.classList.contains('customer__dropdown--open')
  },
  isClickInside(e, customerDropdown) {
    const isClickInside = customerDropdown && customerDropdown.contains(e.target)

    if (!isClickInside && this.isOpen(customerDropdown)) {
      this.doClose(customerDropdown)
    }
  },
  doOpen(customerDropdown) {
    customerDropdown.classList.add('customer__dropdown--open')
  },
  doClose(customerDropdown) {
    customerDropdown.classList.remove('customer__dropdown--open')
  },
}

export default Customer
